// extracted by mini-css-extract-plugin
export default {"documentContainer":"kdies3SwM_MMSUVUI32r"};